module.exports = "/fonts/opensansbold.woff";